import { render, staticRenderFns } from "./IssuesDiscussed.vue?vue&type=template&id=4e2fd334&scoped=true"
import script from "./IssuesDiscussed.vue?vue&type=script&lang=js"
export * from "./IssuesDiscussed.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/checkbox.css?vue&type=style&index=0&id=4e2fd334&prod&scoped=true&lang=css&external"
import style1 from "./IssuesDiscussed.vue?vue&type=style&index=1&id=4e2fd334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fd334",
  null
  
)

export default component.exports